import { useEffect, useState } from 'react';

/**
 * 모바일에서 "주소창이 있는 상태"에서의 실제 화면 높이만 유지하는 훅.
 * 주소창이 사라져도 높이는 증가하지 않음.
 */
// const useVisualViewportHeight = () => {
//   const getCurrentHeight = () =>
//     window.visualViewport?.height || window.innerHeight;

//   // 📌 초기 값 기준으로 최소값 유지
//   const [minHeight, setMinHeight] = useState<number>(getCurrentHeight());

//   useEffect(() => {
//     const handleResize = () => {
//       const current = getCurrentHeight();
//       setMinHeight((prev) => Math.min(prev, current)); // 항상 최소값 유지
//     };

//     window.visualViewport?.addEventListener('resize', handleResize);
//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.visualViewport?.removeEventListener('resize', handleResize);
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   return minHeight;
// };

const useVisualViewportHeight = () => {
  const getCurrentHeight = () =>
    window.visualViewport?.height || window.innerHeight;

  // 📌 초기 값 기준으로 최소값 유지
  const [minHeight, setMinHeight] = useState<number>(getCurrentHeight());

  useEffect(() => {
    const handleResize = () => {
      const current = getCurrentHeight();
      setMinHeight((prev) => Math.min(prev, current)); // 항상 최소값 유지
    };

    const handleOrientationChange = () => {
      // ✅ 오리엔테이션이 바뀌면 현재값으로 다시 초기화
      setTimeout(() => {
        setMinHeight(getCurrentHeight());
      }, 100);
    };

    window.visualViewport?.addEventListener('resize', handleResize);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return minHeight;
};

export default useVisualViewportHeight;
